import { render } from "./ContactUsManagement.vue?vue&type=template&id=d67f439a&scoped=true"
import script from "./ContactUsManagement.vue?vue&type=script&lang=js"
export * from "./ContactUsManagement.vue?vue&type=script&lang=js"

import "./ContactUsManagement.vue?vue&type=style&index=0&id=d67f439a&lang=scss&scoped=true"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67f439a"]])

export default __exports__